import * as Scrivito from "scrivito"

export const Download = Scrivito.provideObjClass("Download", {
  attributes: {
    blob: "binary",
    tags: "stringlist",
    title: "string",
    md5Hash: "string",
    externalId: "string",
    externalLastChanged: "string"
  },
  extractTextAttributes: ["blob:text"]
})

export type DownloadObj = InstanceType<typeof Download>
